<template>
	<div style="padding: 10px; background-color: #fff;margin: 10px;border-radius: 3px;min-height: 97%;">


		<div style="position: sticky;top:0;z-index: 999;background-color: #fff;padding-bottom: 1px;border-bottom: 1px solid #ebeef5;padding-top: 10px;">
			<!--搜索start-->
			<div>
				<el-form size="mini" style="display: flex;flex-wrap: wrap;" :style="{'height':'50px'}" ref="searchForm" :model="searchForm" inline :label-width="isMobile?'220px':'140px'">

					<!--收起时显示的搜索项start 4个搜索项为一行-->
					<div style="width: 80%;display: flex;">

						

						<el-form-item label="用户id" style="width: 27%;display: flex;">
							<el-input v-model="searchForm.user_id" placeholder="请输入用户id" clearable size="mini" />
						</el-form-item>
						
						<el-form-item label="商品id" style="width: 27%;display: flex;">
							<el-input v-model="searchForm.goods_id" placeholder="请输入商品id" clearable size="mini" />
						</el-form-item>
						
					

					</div>
					<!--收起时显示的搜索项end-->

					<div :style="{'width':'13%','justify-content': 'center' }" style="height: 30px; display: flex;margin: 0;margin-bottom: 10px;">
						<el-button round style="margin-right: 10px;" @click="handleSearch" type="primary" icon="el-icon-search" size="small">搜索</el-button>
						<el-button round @click="handleReset" size="small">重置</el-button>

					</div>


				</el-form>
			</div>
			<!--搜索end-->

			<!-- <div style="display: flex;align-items: center;background-color: #fff;margin-bottom: 10px; justify-content: space-between;margin-left: 5px;">

				<div style="margin-right: 20px;margin-left: 25px;">
					<el-button @click="showAddPop" type="primary" round icon="el-icon-plus" size="mini">添加</el-button>
				</div>
			</div> -->
		</div>


		<!--表格start :height="tableHeight+'px'"-->
		<el-table :height="tableHeight" :show-header="false" ref="table" :data="tableData" style="width: 100%;background-color: #fff;margin: 5px;">

			<el-table-column style="width: 100%;">
				<template slot-scope="{ row, index }">
					<div class="tableTem" style="display: flex;">
						<div class="avatar">

							<!--用户图片start-->
							<div style="text-align: center;" class="dis">
								<img :src="row.user?row.user.avatar:''" style="width:70px;height:70px;cursor: pointer;" @click="handlePreView(row.user?row.user.avatar:'')">
								<!-- <div class="titleFont">主图</div> -->
							</div>
							<!--用户图片end-->

							<div style="width: 180px;">
							
								
								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">用户id：</span>
									<el-tooltip :content="row.user?row.user.id+'':'无'" placement="right">
										<div class="dian dianL">{{row.user?row.user.id+'':'无'}}</div>
									</el-tooltip>
								</div>
								
								
								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 70px;text-align: right;">微信名：</span>
									<el-tooltip :content="row.user?row.user.nickname:'无'" placement="right">
										<div class="dian dianL">{{row.user?row.user.nickname:'无'}}</div>
									</el-tooltip>
								</div>
								
								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 70px;text-align: right;">ETM姓名：</span>
									<el-tooltip :content="row.user?row.user.etm_name:'无'" placement="right">
										<div class="dian dianL">{{row.user?row.user.etm_name:'无'}}</div>
									</el-tooltip>
								</div>
								
								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 70px;text-align: right;">ETM昵称：</span>
									<el-tooltip :content="row.user?row.user.etm_nickname:'无'" placement="right">
										<div class="dian dianL">{{row.user?row.user.etm_nickname:'无'}}</div>
									</el-tooltip>
								</div>
								
								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 70px;text-align: right;">ETM会员：</span>
								
									<div v-if="row.user" class="dian dianL">{{row.user.etm_vip==1?'是':'否'}}</div>
									<div v-else class="dian dianL">无</div>
								</div>
								
				

							</div>
						</div>

						<!-- height: 50px; -->
						<ul :style="{'width':isMobile?mobileWidth+'px':'','overflow-x':isMobile?'auto':'','overflow-y':isMobile?'hidden':'','flex-wrap':isMobile?'nowrap':''}">

							<li>
								<div class="content">
									<el-tooltip :content="row.id+''" placement="right">
										<div class="dian">{{row.id}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">日志id</div>
							</li>
							
							<li style="width: 200px;">
								<div class="content" style="display: flex;justify-content: center;align-items: center;">
									
									<div v-if="row.type==1"  >进入小程序</div>
									<div v-if="row.type==2"  >查看商品</div>
									<div v-if="row.type==3"  >添加商品到购物车</div>
									<div v-if="row.type==4" >购买商品</div>
									<div v-if="row.type==5"  >签到打卡</div>
									<div v-if="row.type==6" >开启宝箱</div>
									<div v-if="row.type==7"  >购物积分</div>
									<div v-if="row.type==8"  >积分兑换</div>
									<div v-if="row.type==9"  >积分兑换退回</div>
									
									<div  v-if="row.type==5||row.type==6||row.type==7||row.type==9" style="margin-left: 5px;">+{{row.credit}}</div>
									<div  v-if="row.type==8" style="margin-left: 5px;">-{{row.credit}}</div>
									
								</div>
								<div class="titleFont dian">类型</div>
							</li>
							
							

							<li>
								<div class="content">
									<el-tooltip :content="row.goods?row.goods.id+'':'无'" placement="right">
										<div class="dian">{{row.goods?row.goods.id+'':'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">商品id</div>
							</li>
				

							<li style="width: 250px;">
								<div class="content" style="width: 240px;">
									<el-tooltip :content="row.goods?row.goods.name:'无'" placement="right" style="width: 240px;">
										<div class="dian" style="width: 240px;">{{row.goods?row.goods.name:'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">商品名称</div>
							</li>

							<li>
								<div class="content">
									<img v-if="row.goods" :src="row.goods.image" style="width:50px;height: 30px;margin-top: -20px;border-radius: 3px; cursor: pointer;" @click="handlePreView(row.goods.image)">
									<div v-else>无</div>
								</div>
								<div class="titleFont dian">商品图片</div>
							</li>

							
							<li style="width: 250px;">
								<div class="content" style="width: 240px;">
									<el-tooltip v-if="row.store" :content="row.store.name" placement="right" style="width: 240px;">
										<div class="dian" style="width: 240px;">{{row.store.name}}</div>
									</el-tooltip>
									<div v-else style="text-align: center;">无</div>
								</div>
								<div class="titleFont dian">门店名称</div>
							</li>
							
							
							
							
							
							

							<li>
								<el-tooltip :content="row.create_time+''" placement="right">

									<div class="content dis">
										{{row.create_time | timeBreak2}}
									</div>
								</el-tooltip>
								<div class="titleFont dian">创建时间</div>
							</li>

				



						</ul>

<!-- 
						<div style="width: 100px;display: flex;justify-content: start;align-items: center;margin-left: 10px;">
							<el-dropdown trigger="hover" style="width: 80px;">
								<el-button size="mini" round type="primary">
									操作<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">

									<el-dropdown-item>
										<el-button type="success" size="mini" round @click="showAddPop(row)">编辑
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item v-if="row.deleted_at">
										<el-button type="danger" size="mini" round @click="huiFu(row)">恢复
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item v-else>
										<el-button type="danger" size="mini" round @click="del(row)">停用
										</el-button>
									</el-dropdown-item>


								</el-dropdown-menu>
							</el-dropdown>

						</div> -->

					</div>

				</template>
			</el-table-column>
		</el-table>
		<!--表格end-->
		<!--分页start-->
		<el-row type="flex" justify="end" align="middle" class="page" style="margin-top: 10px;margin-right: 50px;padding-bottom: 10px;">
			<el-pagination background layout="prev, pager, next" :current-page="pageNumber" :page-size="pageSize" :total="total" @current-change="changePage"></el-pagination>
			<span style="font-size: 13px;color: #999;">共 {{total}} 条</span>
		</el-row>
		<!--表格end-->



		<!-- 添加或编辑弹窗start -->
		<el-dialog :close-on-click-modal="false" width="600px" ref="form" custom-class="m-dialog" title="信息" center :visible.sync="isShowAddPop">
			<div v-if="isShowAddPop">
				<div style="padding-top: 20px;">

					<el-form style="margin-left: 80px;" label-width="100px" size="small" ref="form" :rules="formRules" :model="form">

						<el-form-item v-if="!form.admin_id" label="门店" prop="store_id">
							<el-select v-model="form.store_id" clearable placeholder="请选择" style="width: 250px;">
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>


						<el-form-item v-if="!form.admin_id" label="角色" prop="role">
							<el-select v-model="form.role" clearable placeholder="请选择" style="width: 250px;">
								<el-option label="门店" value="store_admin" />
								<el-option label="门店SA" value="store_sa" />
								
								<el-option label="教练" value="store_editor" />
							</el-select>
						</el-form-item>

						<el-form-item label="头像" prop="avatar" style="position: relative;">
							<div style="position: absolute;top: 20px;left: -59px;font-size: 12px;color: #aaa;">300*300</div>
							<upload-img :imgWidth="300" :imgHeight="300" :limit='1' accept="image/png" fileAfterName=".png" ref="fengMianUpload" :imgList="form.avatar"></upload-img>
						</el-form-item>

						<el-form-item label="昵称" prop="nickname">
							<el-input style="width: 250px;" v-model="form.nickname" placeholder="请输入昵称"></el-input>
						</el-form-item>

						<el-form-item label="用户名" prop="username">
							<el-input style="width: 250px;" v-model="form.username" placeholder="请输入用户名"></el-input>
						</el-form-item>

						<el-form-item v-if="!form.admin_id" label="密码" prop="password">
							<el-input type="password" style="width: 250px;" show-password v-model="form.password" placeholder="请输入密码"></el-input>
						</el-form-item>

					</el-form>

				</div>
				<div class="dis" style="justify-content: flex-end;">

					<el-button round style="margin-left: 10px" @click="save('form')" type="primary" size="small">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 添加或编辑弹窗end -->


		<!--浏览图片的弹窗start-->
		<el-dialog :close-on-click-modal="false" width="400px" footer-hide title="预览" :visible.sync="isShowPreImg">
			<img :src="preImgUrl" style="width: 100%">
		</el-dialog>
		<!--浏览图片的弹窗end-->


		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->
	</div>
</template>

<script>
	import {
		ajax
	} from '../../util/ajax.js';
	import uploadImg from '../../components/upload/uploadImg.vue'
	export default {
		name: '',
		components: {
			uploadImg
		},
		data() {
			return {
				mobileWidth:window.mobileWidth+70,
				isMobile:window.isMobile,
				isShowAddPop: false, //是否显示首页添加轮播图弹窗
				isShowPreImg: false, //是否显示浏览图片的弹窗
				preImgUrl: '', //浏览图片弹窗的图片地址
				tableHeight: 0, //表格高度
				loading: false,

				startTime: '',
				endTime: '',

				tabName: '首页轮播图', //tab默认选中项
				searchForm: {}, //首页轮播图的搜索
				tableData: [], //首页轮播图的表格数据

				storeList: [], //门店列表

				isShowCollapse: false, //是否展开搜索
				pageNumber: 1, // 当前页数
				pageSize: 10, // 页面大小
				total: 0,

				shang: require("@/assets/shang.png"),
				xia: require("@/assets/xia.png"),
				sortIndex: -1, //排序项
				sortContent: '', //排序项的值 desc 或esc
				sortFlag: true, //排序箭头切换


				form: {
					admin_id: '',
					store_id: '',
					message:'',
					
					username: '',
					password: '',
					avatar: [],
					role: ''
				},
				formRules: {

					store_id: [{
						required: true,
						message: '请选择门店',
						trigger: 'change'
					}],

					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],

					nickname: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],

					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					avatar: [{
						type: 'array',
						required: true,
						message: '请选择上传头像',
						trigger: 'change'
					}],
					role: [{

						required: true,
						message: '请选择角色',
						trigger: 'change'
					}],

				},




			}
		},

		filters: {
			//把 2021-07-30 11:07:36 格式为 07-30
			//								11:07
			//使用格式 <p>{{row.stateChangeTime | timeBreak(0)}}</p>    <p>{{row.stateChangeTime | timeBreak(1)}}</p> 
			timeBreak(time, type, from) {
				if (time) {
					return type == 0 ? (from == undefined ? time.substr(5, 5) : time.substr(0, 10)) : (type == 2 ? time
					.substr(0, 10) : (from == undefined ? time.substr(11, 5) : time.substr(11, 8)));
				} else {
					return time;
				}
			},

			timeBreak2(val) {

				let v = val.split(' ')[0];

				return v;
			},

		},

		mounted() {
			
			this.initData();
		},

		created() {
			this.getTableHeight();
		},
		mounted() {

			//挂载window.onresize事件(动态设置table高度)
			let _this = this;
			window.onresize = () => {
				if (_this.resizeFlag) {
					clearTimeout(_this.resizeFlag);
				}
				_this.resizeFlag = setTimeout(() => {
					_this.getTableHeight();
					_this.resizeFlag = null;
				}, 100);
			};

			this.getStore();
			this.initData();
		},

		methods: {

			//获取门店列表
			async getStore() {
				let ress = await ajax('/hq/store', 'GET');
				let res = ress.data.data;
				this.storeList = res.store;
			},

			//初始化表格数据
			async initData() {

				this.loading = true


				if (this.searchForm.user_id === "") { //select未选中为空字符串
					this.searchForm.user_id = null; //为null后就不会作为http请求参数了带给后端了
				}
				if (this.searchForm.goods_id === "") { //select未选中为空字符串
					this.searchForm.goods_id = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				
				

				let param = {
					...this.searchForm,
					count: this.pageSize,
					page: this.pageNumber
				};

				let ress = await ajax('/hq/log/user', 'GET', param);
				this.loading = false;
				let res = ress.data.data;
				this.total = res.total;
				this.tableData = res.log;
			},

			//删除
			async del(row) {
				this.$confirm('确定要停用吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true
					let ress = await ajax('/hq/admin/delete', 'DELETE', {
						admin_id: row.id,
						status: 0
					});
					this.loading = false;
					this.$message({
						message: '成功',
						type: 'success'
					});

					this.initData();
				});
			},


			//恢复
			async huiFu(row) {
				this.$confirm('确定要恢复正常吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true
					let ress = await ajax('/hq/admin/delete', 'DELETE', {
						admin_id: row.id,
						status: 1
					});
					this.loading = false;
					this.$message({
						message: '成功',
						type: 'success'
					});

					this.initData();
				});
			},





			//翻页
			changePage(pageNumber) {
				console.log('即将翻到' + pageNumber + '页')

				this.tableData = []; //这种可以让滚动条回到顶部
				this.pageNumber = pageNumber
				this.initData()
			},



			//计算table高度(动态设置table高度)
			getTableHeight() {
				let tableH = 220; //距离页面下方的高度,值越大表格高度越小
				let tableHeightDetil = window.innerHeight - tableH;
				if (tableHeightDetil <= 300) {
					this.tableHeight = 300;
				} else {
					this.tableHeight = window.innerHeight - tableH;
				}
			},


			//点击添加或编辑按钮
			showAddPop(row) {
				if (row.id) { //编辑
					console.log('row===>', row)

					this.form.admin_id = row.id;
					this.form.username = row.username;
					this.form.password = row.password;
					this.form.nickname = row.nickname;
					this.form.avatar = [{
						url: row.avatar
					}];

				} else {
					this.form = {
						admin_id: '',
						store_id: '',
						username: '',
						password: '',
						nickname: '',
						avatar: [],
						role: ''
					};
				}
				this.isShowAddPop = true;
			},
			//浏览图片
			handlePreView(url) {
				this.preImgUrl = url
				this.isShowPreImg = true
			},

			//搜索
			handleSearch() {
				this.pageNumber = 1;
				this.initData()
			},
			//首页轮不同的重置
			handleReset() {
				this.$refs.searchForm.resetFields();
				this.searchForm = {};
				this.sortIndex = -1;
				this.sortContent = ''; //排序的值 desc / esc
				this.sortFlag = true;
				this.pageNumber = 1
				this.pageSize = 10
				this.tableData = []; //表格数据修改为空
				this.initData()

			},

			//添加或编辑的保存
			async save(formName) {


				this.form.avatar = this.$refs.fengMianUpload.getImgList(); //商品封面图
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let url = '/hq/admin/add'
						let method = "POST";
						if (this.form.admin_id) {
							method = 'PUT'
							url = '/hq/admin/edit'
						}
						this.loading = true;
						let ress = await ajax(url, method, {
							admin_id: this.form.admin_id ? this.form.admin_id : null,
							store_id: this.form.store_id ? this.form.store_id : null,
							username: this.form.username,
							avatar: this.form.avatar[0].url,
							password: this.form.password,
							nickname: this.form.nickname,
							role: this.form.role ? this.form.role : null
						});

						this.loading = false;

						this.$refs[formName].resetFields();
						this.form = {
							admin_id: '',
							store_id: '',
							username: '',
							password: '',
							nickname: '',
							avatar: [],
							role: ''
						};

						this.$message({
							message: '成功',
							type: 'success'
						});
						this.isShowAddPop = false;
						this.initData();

					} else {
						this.$message.error('请填写完整信息');
						return false;
					}
				});



			},







		}



	}
</script>

<style scoped>
	.tableTem ul {
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;

	}

	.tableTem ul li {
		list-style: none;

		width: 110px;
		min-height: 60px;
		border-left: 1px solid #ededed;
		border-bottom: 1px solid #ededed;
		margin-bottom: -1px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 3px;


	}

	.tableTem .content {

		padding-top: 3px;
		font-size: 14px;
		color: #2d8cf0;
		font-weight: 600;
	}

	.tableTem .avatar img {
		border-radius: 10px;
		width: 60px;
		height: 60px;
	}

	.tableTem .avatar {

		/* padding-right: 20px; */
		display: flex;
		justify-content: center;

	}

	.tableTem .dian {
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100px;
	}

	.tableTem .dianL {
		text-align: left;
		font-size: 13px;
		color: #333;
	}


	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}





	.sortLine {
		display: flex;
		align-items: center;
	}

	.sortItem {

		height: 100%;
		color: rgb(156, 156, 156);
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		min-width: 80px;
	}

	.sortItem:hover {
		background-color: #9E819F !important;
		color: #fff !important;
	}

	.sortLine .sortItem:last-child {
		border-right: none;
	}

	>>>.el-table tbody tr:hover>td {
		background-color: #ffffff !important
	}


	>>>.el-icon-arrow-down {
		font-size: 12px;
	}

	>>>.demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}

	>>>.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	>>>.el-table td {
		padding: 10px 0 !important;
	}
</style>
